import { MdCreditCard } from "react-icons/md";
import { useSelector } from "react-redux";
import { selectIsOnline } from "../../../../store/slices/networkSlice";
import styles from "./PaymentMethodsContent.module.scss";
import { EmptyState } from "../../../../common/components/emptyState/EmptyState";
import { PaymentMethodCard } from "../paymentMethodCard/PaymentMethodCard";
import { usePaymentMethodsContent } from "../../usePaymentMethodsContent";

interface Props {
  mode: "screen" | "modal";
  onSelect?: (methodId: number) => void;
  selectedId?: number;
}

export const PaymentMethodsContent = ({
  mode,
  onSelect,
  selectedId,
}: Props) => {
  const { methods, deleteMethod, setDefaultMethod } =
    usePaymentMethodsContent();
  const isOnline = useSelector(selectIsOnline);

  if (!methods.length) {
    return (
      <div className={styles.emptyStateContainer}>
        <EmptyState
          icon={MdCreditCard}
          title="Нет сохраненных карт"
          description="Карта сохранится автоматически при первой оплате"
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Офлайн предупреждение только для screen mode */}
      {!isOnline && mode === "screen" && (
        <div className={styles.offlineMessage}>
          <span className={styles.offlineMessageIcon}>⚡️</span>
          <span className={styles.offlineMessageText}>
            Нет подключения к интернету. Управление картами недоступно
          </span>
        </div>
      )}
      <div
        className={`${styles.methodsList} ${mode === "modal" ? styles.modalList : ""}`}
      >
        {methods.map((method) => (
          <PaymentMethodCard
            key={method.id}
            method={method}
            onSetDefault={setDefaultMethod}
            onDelete={deleteMethod}
            isSelectable={mode === "modal"}
            isSelected={selectedId === method.id}
            onSelect={onSelect ? () => onSelect(method.id) : undefined}
            // 👇 дизейблим кнопки только для screen mode в офлайн
            disabled={!isOnline && mode === "screen"}
          />
        ))}
      </div>
    </div>
  );
};
